import { useBooleanFlagValue } from '@openfeature/react-sdk';

import DataDashboard from './DataDashboard';
import DataDashboardLegacy from './DataDashboardLegacy';
import { FeatureFlags } from '../constants/featureFlags';

function DataDashboardGate() {
  const dataDashboardV2Enabled = useBooleanFlagValue(FeatureFlags.DATA_DASHBOARD_V2_ENABLED, false);

  return dataDashboardV2Enabled ? <DataDashboard /> : <DataDashboardLegacy />;
}

export default DataDashboardGate;
